import React from "react";
import { QuoteRequestLeadDetailPage } from "../../../SharedPages/LeadsPage/QuoteRequestLeadDetailPage/QuoteRequestLeadDetailPage";

export function SellerAdminLeadDetail() {
  return <QuoteRequestLeadDetailPage />;
}
